export default __webpack_public_path__ + "static/media/inapp.1683f8d2.png";